module.exports = __webpack_public_path__ + "img/sintesis.6172dcbf.svg";